module.exports = __webpack_public_path__ + "static/media/step_19.75d0a097.mp3";